import { Card, Flex, Typography } from 'antd';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import AvatarWithFallback from '@/components/common/AvatarWithFallback';
import ExpandableText from '@/components/common/ExpandableText';
import { toTitleCase } from '@/utils/commonUtils';
import { formatSponsorLocation } from '@/utils/sponsorPage/helpers';
import { sponsorPropType } from '@/utils/sponsorPage/propTypes';
import useTranslation from '@/hooks/useTranslation';

function SponsorCard({ sponsor, isFetching, fallbackImage }) {
    const navigateTo = useNavigate();
    const { t } = useTranslation();
    const location = formatSponsorLocation(sponsor);
    const navigateSponsor = () => navigateTo(`/sponsor/${sponsor?.id}`);

    return (
        <Card
            size="small"
            hoverable
            style={{
                height: '100%',
                width: '100%',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            }}
            loading={isFetching}
        >
            <Flex gap={16}>
                <Flex>
                    <AvatarWithFallback
                        src={sponsor?.logo_url || fallbackImage}
                        alt={sponsor?.name}
                        shape="circle"
                        size={64}
                        draggable
                        fallbackSrc={fallbackImage}
                        onClick={navigateSponsor}
                    />
                </Flex>
                <Flex>
                    <Flex vertical>
                        <Typography.Title level={4} onClick={navigateSponsor} style={{ cursor: 'pointer' }}>
                            {t(toTitleCase(sponsor?.name))}
                        </Typography.Title>
                        {location && <Typography.Paragraph style={{ margin: 0 }}>{t(location)}</Typography.Paragraph>}
                        <ExpandableText strong>{t(sponsor?.tagline)}</ExpandableText>
                        <ExpandableText>{t(sponsor?.description)}</ExpandableText>
                    </Flex>
                </Flex>
            </Flex>
        </Card>
    );
}

SponsorCard.propTypes = {
    sponsor: sponsorPropType,
    isFetching: PropTypes.bool,
    fallbackImage: PropTypes.string,
};

export default memo(SponsorCard);
